import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../../../stores/CurrentCompanyStore'
import { SalesGraph } from './SalesGraph'
import { ReportFilter } from '../../ReportFilter'
import { SalesReportV2 } from './V2'
import { ReportFilterStore } from '../../ReportFilterStore'
import { AdvancedReportRoutes, InsightsRoutes, Routes } from '../../../../../../constants/Routes'
import { ReportAlert } from '../../ReportAlert'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  reportFilterStore?: ReportFilterStore
}

interface State {
  version: 'v1' | 'v2'
  isAlertExpanded: boolean
}

@inject('currentCompanyStore', 'reportFilterStore')
@observer
export class SalesSummary extends React.Component<Props, State> {
  filterStore = this.props.reportFilterStore!
  currentCompanyStore = this.props.currentCompanyStore!

  constructor(props: Props) {
    super(props)

    this.state = {
      version: 'v2',
      isAlertExpanded: false,
    }
  }

  get inSightReportPath(): string {
    return Routes.INSIGHTS_REPORTS(
      this.currentCompanyStore.company!.id,
      InsightsRoutes.SALES_SUMMARY,
    )
  }

  render() {
    const company = this.props.currentCompanyStore!.company!
    const { startDateString, endDateString, selectedLocationIds } = this.props.reportFilterStore!

    return (
      <>
        <ReportFilter reportPath={this.inSightReportPath} />
        <ReportAlert reportType='insights' reportPath={this.inSightReportPath} />

        <div className='rounded background-white'>
          <div className='p-3'>
            <SalesGraph
              companyId={company.id}
              startDate={startDateString}
              endDate={endDateString}
              locationIds={selectedLocationIds}
            />
          </div>
        </div>
        <br />

        <SalesReportV2
          companyId={company.id}
          locationIds={selectedLocationIds}
          startDate={startDateString}
          endDate={endDateString}
        />
      </>
    )
  }
}
